import featureToggles from 'shared/featureToggles'
import { FLOW_STEP_DATE, FLOW_STEP_PRODUCT, FLOW_STEP_REVIEW, FLOW_STEP_VEHICLE } from 'purchase-flow/constants'

import DateSelection from './DateSelection'
import VehicleSelection from './VehicleSelection'
import ProductSelection from './ProductSelection'
import ReviewPay from './ReviewPay'
import GuestCheckoutVehicleSelection from 'booking/components/GuestCheckoutComponents/GuestCheckoutVehicleSelection'

import styles from './styles.module.scss'

const HourlyFlow = ({
    activeStep,
    grsId,
    onNext,
    setStartDate,
    setProduct,
    bookingData,
    setVehicle,
    rate,
    currentItemIndex,
    rateVehicle,
    errorMessage,
    waitingListKey,
    setOutboundNumber,
    setInboundNumber,
    setAdditionalServices,
    showPixPaymentMethod,
    isParkNowFlow,
    nonBookable,
}) => (
    <div className={featureToggles.hasGuestCheckoutFlow && styles.hourlyFlow}>
        {activeStep === FLOW_STEP_DATE && (
            <DateSelection
                grsId={grsId}
                onNext={onNext}
                setStartDate={setStartDate}
                isParkNowFlow={isParkNowFlow}
                nonBookable={nonBookable}
            />
        )}
        {activeStep === FLOW_STEP_PRODUCT && (
            <ProductSelection
                grsId={grsId}
                onNext={onNext}
                setProduct={setProduct}
                bookingData={bookingData}
                setAdditionalServices={setAdditionalServices}
                nonBookable={nonBookable}
            />
        )}
        {activeStep === FLOW_STEP_VEHICLE &&
            (featureToggles.hasGuestCheckoutFlow ? (
                <GuestCheckoutVehicleSelection onNext={onNext} setVehicle={setVehicle} />
            ) : (
                <VehicleSelection
                    onNext={onNext}
                    setProduct={setProduct}
                    setVehicle={setVehicle}
                    rate={rateVehicle}
                    currentItemIndex={currentItemIndex}
                />
            ))}
        {activeStep === FLOW_STEP_REVIEW && !errorMessage && (
            <ReviewPay
                grsId={grsId}
                bookingData={bookingData}
                currentItemIndex={currentItemIndex}
                waitingListKey={waitingListKey}
                rate={rate}
                setOutboundNumber={setOutboundNumber}
                setInboundNumber={setInboundNumber}
                showPixPaymentMethod={showPixPaymentMethod}
            />
        )}
    </div>
)
export { HourlyFlow }
